import { render, staticRenderFns } from "./Customer.vue?vue&type=template&id=ff94047a"
import script from "./Customer.vue?vue&type=script&lang=js"
export * from "./Customer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff94047a')) {
      api.createRecord('ff94047a', component.options)
    } else {
      api.reload('ff94047a', component.options)
    }
    module.hot.accept("./Customer.vue?vue&type=template&id=ff94047a", function () {
      api.rerender('ff94047a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/chart/Customer.vue"
export default component.exports